"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPath = void 0;

var _pathDescriptions = require("./pathDescriptions");

var getPath = function getPath(name, path) {
  return _pathDescriptions.PATH_DESCRIPTIONS[name] || path || _pathDescriptions.PATH_DESCRIPTIONS['question mark'];
};

exports.getPath = getPath;